export default __webpack_public_path__ + "static/media/close.67ed764f.svg";